import { useRef } from 'react';

export const useLastTrue = (condition, value) => {
	const ref = useRef(value);
	if (condition) {
		ref.current = value;
	}
	return ref.current;
};
